<template>
  <div class="app-container">
    <div class="filter-container">
      <el-input
        v-model="listQuery.long_teng_inn_id"
        placeholder="龙腾酒店ID"
        style="width: 200px"
        class="filter-item"
        clearable
        size="mini"
      />
      <el-input
        v-model="listQuery.long_teng_name"
        placeholder="龙腾酒店名"
        style="width: 200px"
        class="filter-item"
        clearable
        size="mini"
      />
      <el-input
        v-model="listQuery.jin_jiang_inn_id"
        placeholder="锦江酒店ID"
        style="width: 200px"
        class="filter-item"
        clearable
        size="mini"
      />
      <el-input
        v-model="listQuery.jin_jiang_name"
        placeholder="锦江酒店名"
        style="width: 200px"
        class="filter-item"
        clearable
        size="mini"
      />
      <el-select
        v-model="listQuery.status"
        placeholder="状态"
        clearable
        style="width: 90px"
        class="filter-item"
        size="mini"
      >
        <el-option label="未确认" value="non_confirm" />
        <el-option label="已确认" value="confirmed" />
        <el-option label="无效关联" value="invalid" />
      </el-select>
      <el-button
        class="filter-item"
        type="primary"
        icon="el-icon-search"
        @click="handleFilter"
        size="mini"
        >搜索</el-button
      >
    </div>
    <el-table
      size="mini"
      v-loading="listLoading"
      :data="list"
      element-loading-text="Loading"
      border
      fit
      highlight-current-row
    >
      <el-table-column align="center" label="ID" width="95">
        <template slot-scope="scope">
          <!-- {{ scope.$index }} -->
          {{ scope.row.id }}
        </template>
      </el-table-column>
      <el-table-column label="操作员" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.admin?.username || '-' }}
        </template>
      </el-table-column>
      <el-table-column label="龙腾酒店ID" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.long_teng_hotel_inn_id }}
        </template>
      </el-table-column>
      <el-table-column label="龙腾酒店名" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.long_teng_hotel_name }}
        </template>
      </el-table-column>
      <el-table-column label="龙腾酒店电话" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.long_teng_hotel_phone }}
        </template>
      </el-table-column>
      <el-table-column label="龙腾酒店地址" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.long_teng_hotel_address }}
        </template>
      </el-table-column>
      <el-table-column label="锦江酒店ID" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.jin_jiang_hotel_inn_id }}
        </template>
      </el-table-column>
      <el-table-column label="锦江酒店名" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.jin_jiang_hotel_name }}
        </template>
      </el-table-column>
      <el-table-column label="锦江酒店电话" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.jin_jiang_hotel_phone }}
        </template>
      </el-table-column>
      <el-table-column label="锦江酒店地址" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.jin_jiang_hotel_address }}
        </template>
      </el-table-column>
      <el-table-column label="状态" min-width="110" align="center">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.status == 'non_confirm'" type="warning"
            >未确认</el-tag
          >
          <el-tag v-else-if="scope.row.status == 'confirmed'" type="success"
            >已确认</el-tag
          >
          <el-tag v-else-if="scope.row.status == 'invalid'" type="danger"
            >无效关联</el-tag
          >
        </template>
      </el-table-column>

      <el-table-column
        align="center"
        prop="created_at"
        label="创建时间"
        min-width="200"
      >
        <template slot-scope="scope">
          <i class="el-icon-time" />
          <span>{{ scope.row.created_at }}</span>
        </template>
      </el-table-column>
      <el-table-column
        v-if="$canEdit"
        label="操作"
        align="center"
        width="230"
        class-name="small-padding fixed-width"
        fixed="right"
      >
        <template slot-scope="scope">
          <el-button
            v-if="scope.row.status == 'non_confirm'"
            type="success"
            size="mini"
            @click="confirm(scope.row.id)"
            >确认关联</el-button
          >
          <el-button
            v-if="scope.row.status == 'non_confirm'"
            size="mini"
            type="danger"
            @click="invalid(scope.row.id)"
            >无效关联</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination-container">
      <el-pagination
        :current-page="listQuery.page"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="listQuery.limit"
        :total="total"
        background
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
  </div>
</template>

<script>
import request from '@/utils/request'

export default {
  filters: {
    statusFilter(status) {
      const statusMap = {
        published: 'success',
        draft: 'gray',
        deleted: 'danger',
      }
      return statusMap[status]
    },
  },
  data() {
    return {
      list: null,
      total: null,
      listLoading: true,
      listQuery: {
        page: 1,
        limit: 10,
        nickname: '',
        is_forbidden: '',
      },
    }
  },
  created() {
    this.getList()
  },
  methods: {
    getList() {
      this.listLoading = true
      request({
        url: '/api/backend/hotelConfirm/list',
        method: 'get',
        params: this.listQuery,
      }).then((response) => {
        this.list = response.data.data
        this.total = response.data.total
        this.listLoading = false
      })
    },
    handleFilter() {
      this.listQuery.page = 1
      this.getList()
    },
    handleSizeChange(val) {
      this.listQuery.limit = val
      this.getList()
    },
    handleCurrentChange(val) {
      this.listQuery.page = val
      this.getList()
    },
    handleForbid(val, text) {
      this.$confirm('此操作将' + text + '该用户, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          request({
            url: '/api/backend/user/forbid',
            method: 'get',
            params: { id: val },
          }).then(() => {
            this.getList()
            this.$message({
              type: 'success',
              message: '操作成功!',
            })
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消',
          })
        })
    },
    confirm(val) {
      this.$confirm('此操作修改日志, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          request({
            url: '/api/backend/hotelConfirm/confirm',
            method: 'get',
            params: { id: val },
          }).then(() => {
            this.getList()
            this.$message({
              type: 'success',
              message: '操作成功!',
            })
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消',
          })
        })
    },
    invalid(val) {
      this.$confirm('此操作修改日志, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          request({
            url: '/api/backend/hotelConfirm/invalid',
            method: 'get',
            params: { id: val },
          }).then(() => {
            this.getList()
            this.$message({
              type: 'success',
              message: '操作成功!',
            })
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消',
          })
        })
    },
  },
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.user-avatar {
  width: 40px;
  height: 40px;
  border-radius: 6px;
}
</style>
